import { Box, Stack, Typography } from '@mui/material'
import { pieArcLabelClasses, PieChart } from '@mui/x-charts'
import { IReport } from '../../interface/IReport'
import { useSelector } from 'react-redux'
import { IProject } from '../../interface/IProjects'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const StatisticsProjects = (props: any) => {
    const { colorScheme } = props as { colorScheme: string[] }
    const { colorExtendScheme } = props as { colorExtendScheme: string[] }
    const report: IReport[] = useSelector((state: any) => state.report?.value)
    const projects: IProject[] = useSelector((state: any) => state.projects?.value)
    const { t } = useTranslation()

    const [drillDown, setDrillDown] = useState<number>(-1)

    const groupedProjects = report
        .flatMap((entry) => entry.calendarLines)
        .reduce((acc, line) => {
            const projectActivity = line.mserp_indirectactivitycategoryid.toUpperCase() !== 'SYSTEM'
            const projectId = projectActivity ? line.mserp_projectid : line.mserp_timeandattendancejobid
            const activityId = line.mserp_timeandattendancejobid
            const projectName = projects.find((item) => item.mserp_projectid === (projectActivity ? line.mserp_projectid : line.mserp_timeandattendancejobid))?.mserp_projectname

            acc[projectId] ??= { projectId, projectName, activities: {} }

            if (!acc[projectId].activities[activityId]) {
                const activityId = line.mserp_timeandattendancejobid
                const activityName = projectActivity ? projects.find((item) => item.mserp_projectid === line.mserp_projectid)?.activities?.find((act: any) => act.mserp_jobid === line.mserp_timeandattendancejobid)?.mserp_description : projectName

                acc[projectId].activities[activityId] = {
                    activityId,
                    activityName,
                    totalTime: 0,
                    category: line.mserp_indirectactivitycategoryid,
                }
            }

            acc[projectId].activities[activityId].totalTime += line.mserp_calculatedtimeseconds / 60.0 / 60.0 || 0

            return acc
        }, {})

    const groupedProjectsArray = Object.values(groupedProjects)
        .map((proj: any) => ({
            ...proj,
            activities: Object.values(proj.activities),
            totalTime: Object.values(proj.activities).reduce((sum: number, activity: any) => sum + activity.totalTime, 0),
        }))
        .filter((line) => line.projectId)
        .filter((entry) => entry.projectId !== `${process.env.REACT_APP_JID_START}` && entry.projectId !== `${process.env.REACT_APP_JID_STOP}` && entry.projectId !== `${process.env.REACT_APP_JID_BREAK}`)

    return (
        <>
            <Typography variant="h6">{t('report.distributionofhours')}</Typography>

            <Typography variant="body2" color="textSecondary">
                {drillDown === -1 ? t('report.distributionofhoursinfo') : `${t('report.selectedproject')} ${groupedProjectsArray[drillDown]?.projectId} - ${groupedProjectsArray[drillDown]?.projectName}`}
            </Typography>

            <Stack direction="row" width="100%" textAlign="center" spacing={2}>
                <Box>
                    <PieChart
                        series={[
                            {
                                data:
                                    drillDown === -1
                                        ? groupedProjectsArray.map((entry, i) => ({
                                              id: i,
                                              value: entry.totalTime,
                                              label: `${entry.projectId} - ${entry.projectName}`,
                                          }))
                                        : groupedProjectsArray[drillDown]?.activities
                                              ?.filter((line: { totalTime: number }) => line.totalTime > 0)
                                              .map(
                                                  (
                                                      entry: {
                                                          activityName: any
                                                          activityId: any
                                                          totalTime: any
                                                          Project: any
                                                          ProjectName: any
                                                      },
                                                      i: any
                                                  ) => ({
                                                      id: i,
                                                      value: entry.totalTime,
                                                      label: `${entry.activityId} - ${entry.activityName}`,
                                                  })
                                              ),
                                innerRadius: 35,
                                highlightScope: { fade: 'global', highlight: 'item' },
                                faded: { innerRadius: 30, additionalRadius: -15, color: 'gray' },
                                valueFormatter: (item: { value: number }) => `${item.value}h`,
                                arcLabel: (item) => `${item.value}h`,
                            },
                        ]}
                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fontWeight: 'bold',
                                fontSize: 14,
                                fill: 'white',
                            },
                        }}
                        height={400}
                        width={1000}
                        colors={drillDown === -1 ? colorScheme : colorExtendScheme}
                        margin={{ bottom: 100, top: 20, left: 0, right: 0 }}
                        slotProps={{
                            legend: {
                                direction: 'horizontal',
                                position: { vertical: 'bottom', horizontal: 'center' },
                            },
                        }}
                        onItemClick={(event, value) => setDrillDown(drillDown >= 0 ? -1 : value.dataIndex)}
                    />
                </Box>
            </Stack>
        </>
    )
}

export default StatisticsProjects
